
document.addEventListener('DOMContentLoaded', function() {
    const isVisualizerPage = /pages\/customizer-tool/.test(window.location.href);
    if(isVisualizerPage){
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    const productHandle = getParameterByName('product_handle');
    const pattern = getParameterByName('repeated_pattern');
    if (productHandle) {
        fetch(`/products/${productHandle}.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data && data.product) {
                    const productName = data.product.title;
                    const productCartId = data.product.id;
                    console.log(data.product);
                    document.getElementById('product-name').innerText = productName;
                } else {
                    console.error('Invalid product data:', data);
                    document.getElementById('product-name').innerText = 'Product not found';
                }
            })
            .catch(error => console.error('Error fetching product details:', error));

        document.getElementById('back-button').addEventListener('click', function() {
            window.location.href = `/products/${productHandle}`;
        });
    } else {
        console.error('Product handle is missing from the URL');
        document.getElementById('product-name').innerText = 'Product handle missing';
    }

    document.getElementById('opacity-button').addEventListener('click', function() {
        var sliderContainer = document.getElementById('slider-container');
        if (sliderContainer.style.display === 'none') {
            sliderContainer.style.display = 'block';
        } else {
            sliderContainer.style.display = 'none';
        }
    });


    

    let panelWidth = 48;
    let minWidth = 96;
    let maxWidth = 1200;
    let minHeight = 72;
    let maxHeight = 144;
    var canvas;
    let firstLoad = true;
    const opacitySlider = document.getElementById('opacity');
    let isBlackAndWhite = false;
    // let patternRepeated = $('.app').attr('pattern-repeated');
    
    let patternRepeated = pattern;
    console.log(patternRepeated);
    let appElement = document.querySelector('.app');
    appElement.setAttribute('pattern-repeated', patternRepeated);
     // Use 'true' as default if not provided
    console.log('pattern repeated', patternRepeated);
    let imgPath = getParameterByName('wallpaper_image');
    let imgPath_bw = getParameterByName('bw_wallpaper_image');
    let imagesLoaded = false;

    console.log(imgPath, imgPath_bw);

    function renderMsr(prmTarg, prmMsr) {
        //console.log('prmMsr', prmMsr)
        for (i = 0; i < (prmMsr + 1); i++) {
            //console.log(i % 12)
            if (i % 12 == 0) {
                $('.app .' + prmTarg + ' .msr').append('<div class="ln full"><div class=tx>' + i + 'in</div></div>');
            } else if (i % 6 == 0) {
                $('.app .' + prmTarg + ' .msr').append('<div class="ln mid"></div>');
            } else {
                $('.app .' + prmTarg + ' .msr').append('<div class="ln sm"></div>');
            }
        }

        $('.app .ruler .msr .ln').each(function (i) {
            if (i % 48 == 0) {
                //console.log(i)
                $('.app .' + prmTarg + ' .msr .ln').eq(i).addClass('pn');
            }
        });

        if (prmTarg == 'ruler_top') {
            $('.app .' + prmTarg + ' .msr').append('<div class="last"><div class=tx>' + maxWidth + 'in</div></div>');
        } else if (prmTarg == 'ruler_left') {
            $('.app .' + prmTarg + ' .msr').append('<div class="last"><div class=tx>' + maxHeight + 'in</div></div>');
        }
    }


    function renderScene(prmWidth, prmHeight) {
        $('.app .msr').html('');
        renderMsr('ruler_top', prmWidth);
        renderMsr('ruler_left', prmHeight);

        $('.app .ruler .msr .last').hide();
        if (prmWidth == maxWidth) {
            $('.app .ruler_top .msr .last').show();
        }

        $('.app .ruler_top .msr .ln.full').removeClass('hide');
        $('.app .ruler_top .msr .ln.sm').show();
        $('.app .ruler_top .msr .ln.md').show();
        $('.app .ruler_top .msr .ln .tx').show();

        $('.app .ruler_left .msr .ln.full').removeClass('hide');
        $('.app .ruler_left .msr .ln.sm').show();
        $('.app .ruler_left .msr .ln.md').show();
        $('.app .ruler_left .msr .ln .tx').show();

        let aspectRatio = prmWidth / prmHeight;
        //console.log(aspectRatio);
        if (aspectRatio > 1) {
            //console.log("canvas is horizontal")
            $('.app canvas').width($('.app').width() - 100);
            $('.app canvas').height(parseInt(($('.app canvas').width()) / aspectRatio));
            //alert(aspectRatio)
            if ($('.app canvas').height() > $('.app').height() - 100) {
                $('.app canvas').height(parseInt($('.app').height() - 100));
                $('.app canvas').width(parseInt(($('.app').height() - 100) * aspectRatio));
            }

        } else if (aspectRatio == 1) {
            //console.log("canvas is square")
            $('.app canvas').height($('.app').height() - 100);
            $('.app canvas').width(parseInt($('.app canvas').height()));

        } else {
            //console.log("canvas is vertical")
            $('.app canvas').height($('.app').height() - 100);
            $('.app canvas').width((parseInt($('.app canvas').height()) * aspectRatio));

        }

        let canvasWidth = $('.app canvas').width();
        let canvasHeight = $('.app canvas').height();

        if (firstLoad == false) {
            canvas.setWidth(canvasWidth);
            canvas.setHeight(canvasHeight);
        }


        $('.app .ruler_left').css({ 'width': canvasHeight })

        let totalLinesTop = $('.app .ruler_top .msr .ln').length - 1;
        let totalLinesLeft = $('.app .ruler_left .msr .ln').length - 1;
        $('.app .ruler_top .msr .ln').each(function (i) {
            $('.app .ruler_top .msr .ln').eq(i).css({ 'left': (i * canvasWidth / totalLinesTop) });
        });
        $('.app .ruler_left .msr .ln').each(function (i) {
            $('.app .ruler_left .msr .ln').eq(i).css({ 'left': (i * canvasHeight / totalLinesLeft) });
        });

        let xpos = $('.app .ruler_top .msr .ln.full').eq(1).position().left;
        //console.log(xpos)
        if (xpos < 40) {
            $('.app .ruler_top .msr .ln.full').each(function (index) {
                if (index % 2) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                    $('.app .ruler_top .msr .ln.sm').hide();
                }
            });
            $('.app .ruler_left .msr .ln.full').each(function (index) {
                if (index % 2) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                    $('.app .ruler_left .msr .ln.sm').hide();
                }
            });
        }
        if (xpos < 22) {
            $('.app .ruler_top .msr .ln.full').each(function (index) {
                if (index % 4) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                }
            });
            $('.app .ruler_top .msr .ln.mid').hide();
            $('.app .ruler_left .msr .ln.full').each(function (index) {
                if (index % 4) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                }
            });
            $('.app .ruler_left .msr .ln.mid').hide();
        }
        if (xpos < 13) {
            $('.app .ruler_top .msr .ln.full').each(function (index) {
                if (index % 8) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                }
            });
            $('.app .ruler_left .msr .ln.full').each(function (index) {
                if (index % 8) {
                    $(this).addClass('hide');
                    $(this).find('.tx').hide();
                }
            });
            $('.app .ruler_left .msr .last').show();
        }
        $('.app .ruler_top .lbl span').text(prmWidth)
        $('.app .ruler_left .lbl span').text(prmHeight)

    }


    renderScene(parseInt($('#inpWidth').val()), parseInt($('#inpHeight').val()));

    canvas = new fabric.Canvas('c', {
        width: $('.app canvas').width(),
        height: $('.app canvas').height()
    });


    fabric.Image.fromURL(imgPath, function (img) {
        if (img.width != 0) {
            fabric.Image.fromURL(imgPath_bw, function (img_bw) {
                if (img_bw.width != 0) {
                    $('.app .loader').hide();
                    imagesLoaded = true;
                    let shape = new fabric.Rect({
                        width: canvas.width,
                        height: canvas.height,
                        left: 0,
                        top: 0,
                        hasControls: false,
                        hasBorders: false
                    });
                    let scale = $('canvas').height() / img.height;
                    let imageInitialRenderWidth = img.width * scale;
                    let imageRenderWidth = img.width * scale;
                    let imageRenderHeight = img.height * scale;
                    let canvasWidth = $('canvas').width();
                    let multiplier = Math.ceil($('canvas').width() / imageRenderWidth);
                    let fabricPattern = new fabric.Pattern({
                        source: img._element,
                        repeat: 'repeat',
                    })
                    let fabricPattern_bw = new fabric.Pattern({
                        source: img_bw._element,
                        repeat: 'repeat',
                    })
                    //console.log(fabricPattern, fabricPattern_bw)
                    if (patternRepeated == 'true') {

                        if (imageRenderWidth <= canvasWidth) {
                            shape.set('width', imageInitialRenderWidth * multiplier);
                        }
                        if (imageRenderWidth > canvasWidth) {
                            shape.set('width', imageRenderWidth);
                        }
                        shape.set('fill', fabricPattern);
                        fabricPattern.patternTransform = [scale, 0, 0, scale, 0, 0];
                        shape.set('left', -((imageRenderWidth * multiplier) - canvasWidth) / 2);
                    } else {
                        if (imageRenderWidth <= canvasWidth) {
                            shape.set('width', canvasWidth);
                            shape.set('height', $('canvas').width() * (img.height / img.width));
                            shape.set('fill', fabricPattern);
                            fabricPattern.patternTransform = [canvasWidth / img.width, 0, 0, canvasWidth / img.width, 0, 0]
                            shape.set('left', 0);
                        } else {
                            shape.set('width', imageRenderWidth);
                            shape.set('fill', fabricPattern);
                            fabricPattern.patternTransform = [scale, 0, 0, scale, 0, 0];
                            shape.set('left', -(shape.width - canvasWidth) / 2);
                        }
                        let renderHeight = $('canvas').width() * (img.height / img.width);
                        if (renderHeight < $('canvas').height()) {
                            shape.set('top', 0);
                        } else {
                            shape.set('top', -(renderHeight - $('canvas').height()) / 2);
                        }

                    }

                    //console.log(shape)
                    canvas.add(shape);
                    canvas.renderAll();


                    $('#inpWidth, #inpHeight').change(function () {
                        if ($('#inpWidth').val() > maxWidth) {
                            $('#inpWidth').val(maxWidth);
                        }
                        if ($('#inpWidth').val() < minWidth) {
                            $('#inpWidth').val(minWidth);
                        }
                        if ($('#inpHeight').val() > maxHeight) {
                            $('#inpHeight').val(maxHeight);
                        }
                        if ($('#inpHeight').val() < minHeight) {
                            $('#inpHeight').val(minHeight);
                        }

                        renderScene(parseInt($('#inpWidth').val()), parseInt($('#inpHeight').val()));
                        renderPanel();
                        let scale = $('canvas').height() / img.height;
                        let imageRenderWidth = img.width * scale;
                        let canvasWidth = $('canvas').width();

                        let multiplier = Math.ceil($('canvas').width() / imageRenderWidth);
                        let renderHeight = $('canvas').width() * (img.height / img.width);
                        if (patternRepeated == 'true') {
                            shape.scaleToWidth($('canvas').height());
                            shape.scaleToHeight($('canvas').height());
                            shape.set('width', imageInitialRenderWidth * multiplier);
                            shape.set('left', -((imageRenderWidth * multiplier) - canvasWidth) / 2);
                        } else {
                            if (imageRenderWidth <= canvasWidth) {
                                shape.scaleToWidth($('canvas').width());      
                                shape.set('left', 0);
                                shape.set('top', -(renderHeight - $('canvas').height()) / 2);
                            } else {
                                shape.scaleToHeight($('canvas').height());
                                shape.set('left', -((imageRenderWidth * multiplier) - canvasWidth) / 2);
                                shape.set('top', 0);
                            }
                        }

                        canvas.remove(shape);
                        canvas.add(shape);
                        canvas.renderAll();
                    })

                    $("#showGrayscale").click(function () {
                        let patternTransform = shape.fill.patternTransform;
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            shape.set('fill', fabricPattern);
                            isBlackAndWhite = isBlackAndWhite;
                        } else {
                            $(this).addClass('active');
                            shape.set('fill', fabricPattern_bw);
                            isBlackAndWhite = !isBlackAndWhite;
                        }
                        fabricPattern_bw.patternTransform = patternTransform;
                        canvas.renderAll();

                    });

                    $("#flip").click(function () {
                        let targ = canvas.getObjects('group');
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            shape.set('flipX', false);
                        } else {
                            $(this).addClass('active');
                            shape.set('flipX', true);
                        }
                        canvas.renderAll();
                    });

                    var slider = document.getElementById("opacity");
                    slider.oninput = function () {
                        // output.innerHTML = this.value;
                        shape.opacity = this.value / 100
                        canvas.renderAll();
                    }

                } else {
                    $('.app .loader').text("BW Image not found");
                }

            }, {
                crossOrigin: 'anonymous'
            });
        } else {
            $('.app .loader').text("Image not found");
        }

    }, {
        crossOrigin: 'anonymous'
    });




    firstLoad = false;

    function renderPanel() {
        let totalPanels = 0;
        let inpWidth = parseInt($('#inpWidth').val());
        $('.app .panel').html('');
        if (inpWidth > panelWidth) {
            for (i = 0; i < (inpWidth + 1); i++) {
                if (i % panelWidth == 0) {
                    let canvasWidth = $('.app canvas').width();
                    let inpWidth = parseInt($('#inpWidth').val());
                    totalPanels++;
                    $('.app .panel').append('<div class="ln" style="left: ' + (canvasWidth / inpWidth) * (totalPanels * panelWidth) + 'px"></div>');
                }
            }
        }
    }
    renderPanel();



    $('.app canvas').hover(function () {
        if ($('#showRuler').hasClass('active')) {
            $('.app .redline').show();
            $('.app .tooltip').show();
        }
    }, function () {
        $('.app .redline').hide();
        $('.app .tooltip').hide();
    })

    $('.app canvas').on('mousemove', function (e) {
        let mouseX = e.offsetX;
        let mouseY = e.offsetY;

        $('.app .ruler_top .redline').css('left', mouseX);
        $('.app .ruler_left .redline').css('right', mouseY);

        let canvasWidth = $('.app canvas').width();
        let canvasHeight = $('.app canvas').height();
        let inpWidth = parseInt($('#inpWidth').val());
        let inpHeight = parseInt($('#inpHeight').val());
        $('.app .tooltip').css({ 'top': mouseY + 30, 'left': mouseX + 30 });
        $('.app .tooltip').html(parseFloat(mouseX / (canvasWidth / inpWidth)).toFixed(2) + 'In x ' + Math.abs((parseFloat(mouseY / (canvasHeight / inpHeight)) - inpHeight)).toFixed(2) + 'In');

    })


    $("#showRuler").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.icon-title-rulers').text('SHOW RULERS');
            $('.app .ruler .msr').hide();
            $('.app .ruler .lbl').removeClass('active');
        } else {
            $(this).addClass('active');
            $('.icon-title-rulers').text('HIDE RULERS');
            $('.app .ruler .msr').show();
            renderScene(parseInt($('#inpWidth').val()), parseInt($('#inpHeight').val()));
            $('.app .ruler .lbl').addClass('active');
        }
    });

    $("#showPanels").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.icon-title-panels').text('SHOW PANELS');
            $('.app .panel').hide();
        } else {
            $(this).addClass('active');
            $('.icon-title-panels').text('HIDE PANELS');
            $('.app .panel').show();
        }
    });

   

    canvas.on('object:moving', function (event) {
        if (event.target.left >= 0) {
            event.target.left = 0;
        }
        if (event.target.top >= 0) {
            event.target.top = 0;
        }

        let lastX = (event.target.width * event.target.scaleX) - $('canvas').width();
        let lastY = (event.target.height * event.target.scaleY) - $('canvas').height();

        if (event.target.left < -lastX) {
            event.target.left = -lastX;
        }
        if (event.target.top < -lastY) {
            event.target.top = -lastY;
        }
    });

    document.querySelectorAll('.swatch-price').forEach(function(priceElement) {
        var price = parseFloat(priceElement.getAttribute('data-price')).toFixed(2);
        priceElement.innerHTML = `<span class="bold-text">$${price}* / sq. ft</span>`;
        console.log(price);
    });
    

    const heightInput = document.getElementById('inpHeight');
    const widthInput = document.getElementById('inpWidth');
    const costOutput = document.getElementById('cost');
    const substrateButtons = document.querySelectorAll('.substrate-options');
    const addToCartButton = document.getElementById('customAddToCartButton');

    addToCartButton.disabled = true;
    

    function calculateSquareFeet() {
        let height = parseFloat(heightInput.value);
        let width = parseFloat(widthInput.value);

        if (isNaN(height) || isNaN(width)) {
            return 0;
        }

        height = Math.max(Math.min(height, 144), 72);
        width = Math.max(Math.min(width, 1200), 96);

        return ((height * width) / 144).toFixed(2);
    }

    function updateTotalCost() {
        const squareFeet = calculateSquareFeet();

        const selectedButton = document.querySelector('.substrate-options.selected');
        if (selectedButton) {
            const selectedPrice = parseFloat(selectedButton.querySelector('.swatch-price').getAttribute('data-price'));
            if (!isNaN(selectedPrice)) {
                const totalCost = (squareFeet * selectedPrice).toFixed(2);
                costOutput.textContent = totalCost;
            } else {
                costOutput.textContent = '0.00';
            }
        } else {
            costOutput.textContent = '0.00';
        }
    }

    function enforceMinMaxValues() {
        let height = parseFloat(heightInput.value);
        console.log('height minmax', height);
        let width = parseFloat(widthInput.value);

        if (isNaN(height) || height < minHeight) {
            height = minHeight;
        } else if (height > maxHeight) {
            height = maxHeight;
        }

        if (isNaN(width) || width < minWidth) {
            width = minWidth;
        } else if (width > maxWidth) {
            width = maxWidth;
        }

        heightInput.value = height;
        widthInput.value = width;

        updateTotalCost();
    }

    heightInput.addEventListener('input', updateTotalCost);
    widthInput.addEventListener('input', updateTotalCost);

    heightInput.addEventListener('blur', enforceMinMaxValues);
    widthInput.addEventListener('blur', enforceMinMaxValues);

   

    function handleButtonClick(selectedButton, buttons) {
        buttons.forEach(btn => {
            btn.classList.remove('selected');
            const iconCheckmark = btn.querySelector('.icon-checkmark');
            iconCheckmark.querySelector('.icon-solid').style.display = 'none';
            iconCheckmark.querySelector('.icon-regular').style.display = 'block';
        });
        selectedButton.classList.add('selected');
        updateCheckmark(selectedButton);
    
        addToCartButton.disabled = false;
    }

    function updateCheckmark(button) {
        const iconCheckmark = button.querySelector('.icon-checkmark');
        iconCheckmark.querySelector('.icon-solid').style.display = 'block';
        iconCheckmark.querySelector('.icon-regular').style.display = 'none';
    }

    updateCheckmarks(substrateButtons);

    function updateCheckmarks(buttons) {
        buttons.forEach(button => {
            const iconCheckmark = button.querySelector('.icon-checkmark');
            if (button.classList.contains('selected')) {
                iconCheckmark.querySelector('.icon-solid').style.display = 'block';
                iconCheckmark.querySelector('.icon-regular').style.display = 'none';
            } else {
                iconCheckmark.querySelector('.icon-solid').style.display = 'none';
                iconCheckmark.querySelector('.icon-regular').style.display = 'block';
            }
        });
    }

    substrateButtons.forEach(button => {
        button.addEventListener('click', function() {
            handleButtonClick(button, substrateButtons);
            updateTotalCost();

            addToCartButton.disabled = false;
        });

    });

// Function to show loading spinner
function showLoadingSpinner() {
    $('#loading-spinner').show();
}

// Function to hide loading spinner
function hideLoadingSpinner() {
    $('#loading-spinner').hide();
}

// Storing Canvas data to image
function getCanvasImageDataURL() {
    const canvas = document.querySelector('.canvas-container canvas');
    console.log(canvas);
    return canvas.toDataURL('image/png'); // Convert canvas to a data URL
}

//Modal Functionality
const modalOverlay = document.getElementById('modalOverlay');
const modalCart = document.getElementById('modalCart');
const modal = document.getElementById('modal');
const modalCartBtn = document.getElementById('modalCartbtn');
const measurementGuide = document.querySelector('#measurment-guide-icon');
const closeModalBtn = document.getElementById('closeModalBtn');
const closeModalBtnCart = document.getElementById('closeModalBtnCart');

function openModal() {
    // First, display the modal and overlay
    modal.style.display = 'block';
    modalOverlay.style.display = 'block';

    // Allow the display change to take effect before adding the transition classes
    requestAnimationFrame(() => {
        modal.classList.add('show');
        modalOverlay.classList.add('show');
    });
}

function openCartModal() {
    modalCartBtn.style.display = 'block';
    modalCart.style.display = 'block';

    requestAnimationFrame(() => {
        modalCartBtn.classList.add('show');
        modalCart.classList.add('show');
    });
}


function closeModal() {
    // Remove the transition classes to start the closing animation
    modal.classList.remove('show');
    modalOverlay.classList.remove('show');

    // Wait for the animation to complete before hiding the modal
    modal.addEventListener('transitionend', function handler() {
        modal.style.display = 'none';
        modalOverlay.style.display = 'none';
        modal.removeEventListener('transitionend', handler);
    }, { once: true });
}

function closeCartModal(){
    modalCartBtn.classList.remove('show');
    modalCart.classList.remove('show');

    modalCartBtn.addEventListener('transitionend', function handler(){
        modalCartBtn.style.display = 'none';
        modalCart.style.display = 'none';
        modalCartBtn.removeEventListener('transitionend', handler);
        location.reload();
    }, { once: true });
}

measurementGuide.addEventListener('click', openModal);
closeModalBtn.addEventListener('click', closeModal);
modalOverlay.addEventListener('click', closeModal);
closeModalBtnCart.addEventListener('click', closeCartModal);


//Add to Cart Logic
$(document).on('click', '#customAddToCartButton', function () {
    // Show the loading spinner when the process starts
    showLoadingSpinner();
  
    const productCartId = 46177393967274;
    const productHandle = getParameterByName('product_handle');
  
    if (productHandle) {
      // Step 1: Fetch cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const isAlreadyInCart = cart.items.some(item => item.id === productCartId);
  
          if (isAlreadyInCart) {
            console.log('Item is already in the cart. Skipping add.');
            hideLoadingSpinner();
            openCartModal() ;



             // Hide the spinner if no action is taken
            return; // Exit early, preventing further execution
          }
  
          console.log('Item not in the cart. Proceeding to add.');
  
          // Step 2: Fetch product data
          return fetch(`/products/${productHandle}.json`)
            .then(response => {
              if (!response.ok) throw new Error('Network response was not ok');
              return response.json();
            })
            .then(data => {
              if (!data || !data.product) throw new Error('Invalid product data');
  
              const id = productCartId;
              const price = parseFloat(jQuery('#cost').text());
              const title = jQuery('#product-name').text();
              const productId = 8007678591146;
              const canvasImageDataURL = getCanvasImageDataURL();
  
              console.log('Canvas image URL captured:', canvasImageDataURL);
  
              return { id, canvasImageDataURL, price, title, productId };
            })
            .then(({ id, canvasImageDataURL, price, title, productId }) => {
              // Step 3: Upload the image
              return $.ajax({
                url: 'https://www.wallpapertool-fandd.com/upload.php',
                type: 'POST',
                data: { image: canvasImageDataURL },
              }).then(imgUrl => ({ id, imgUrl, price, title, productId }));
            })
            .then(({ id, imgUrl, price, title, productId }) => {
              // Step 4: Update the price
              return $.ajax({
                url: 'https://www.wallpapertool-fandd.com/api.php',
                type: 'POST',
                data: { variantId: id, newPrice: price },
              }).then(() => ({ id, imgUrl, title, productId }));
            })
            .then(({ id, imgUrl, title, productId }) => {
              // Step 5: Update the title and featured image
              return $.ajax({
                url: 'https://www.wallpapertool-fandd.com/product.php',
                type: 'POST',
                data: {
                  productId: productId,
                  newTitle: title,
                  newImageSrc: imgUrl,
                },
              }).then(() => ({ id, imgUrl }));
            })
            .then(({ id, imgUrl }) => {
              // Step 6: Add the item to the cart
              const opacityPercentage = opacitySlider.value ? `${opacitySlider.value}%` : '100%';
              const desaturated = isBlackAndWhite ? 'Yes' : 'No';
  
              const customData = {
                'Width': jQuery('#inpWidth').val(),
                'Height': jQuery('#inpHeight').val(),
                'Substrate': jQuery('.substrate-options.selected .substrate-text .bold-name').text(),
                'Opacity': opacityPercentage,
                'Desaturated': desaturated,
                'Canvas Image': imgUrl,
              };
  
              return $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                  id: id,
                  quantity: 1,
                  properties: customData,
                },
                dataType: 'json',
              });
            })
            .then(response => {
              console.log('Item added to cart successfully:', response);
  
              opacitySlider.value = 100;
              isBlackAndWhite = false;
              hideLoadingSpinner(); // Hide the loading spinner when done
              location.href = '/cart';
            });
        })
        .catch(error => {
          console.error('Error during process:', error);
          hideLoadingSpinner(); // Hide the loading spinner on error
        });
    } else {
      console.error('Product handle is missing from the URL');
      document.getElementById('product-name').innerText = 'Product handle missing';
      hideLoadingSpinner(); // Hide the loading spinner on error
    }
  });
  
    function reorderElements() {
        const contentRight = document.querySelector('.content-right');
        const buttonGrid = document.querySelector('.button-grid');
        const totalCostContainer = document.querySelector('.total-cost-container');
        const wallpaperCalculator = document.querySelector('.wallpaper-calculator');
        const substrateOptions = document.querySelector('.substrate-all-options');
        const wallSpec = document.querySelector('.wall-spec.border-remove');
        const desktopOnlyMessage = document.getElementById('desktopOnlyMessage');
    
        // Ensure all elements exist before proceeding
        if (!contentRight || !buttonGrid || !totalCostContainer) {
            console.warn('Missing required elements. Aborting reorder.');
            return;
        }
    
        if (window.innerWidth <= 960) {
            // Move the total-cost-container below the button-grid on mobile
            contentRight.appendChild(totalCostContainer);
    
            // Hide all elements by default on mobile
            if (wallpaperCalculator) wallpaperCalculator.style.display = 'none';
            if (substrateOptions) substrateOptions.style.display = 'none';
            if (wallSpec) wallSpec.style.display = 'none';
            totalCostContainer.style.display = 'none';
    
            // Show the desktop-only message on mobile if needed
            if (desktopOnlyMessage) {
                desktopOnlyMessage.style.display = 'block';
            }
    
        } else {
            // Move the total-cost-container back to its original position on desktop
            if (contentRight.contains(totalCostContainer) && contentRight.contains(buttonGrid)) {
                contentRight.insertBefore(totalCostContainer, buttonGrid);
            } else {
                console.warn('Cannot reorder elements because their parent-child relationship is broken.');
            }
    
            // Reset display properties to their default state on desktop
            if (wallpaperCalculator) wallpaperCalculator.style.display = '';
            if (substrateOptions) substrateOptions.style.display = '';
            if (wallSpec) wallSpec.style.display = '';
            totalCostContainer.style.display = '';
            totalCostContainer.style.marginTop = ''; // Reset margin-top
    
            // Hide the desktop-only message on desktop
            if (desktopOnlyMessage) {
                desktopOnlyMessage.style.display = 'none';
            }
        }
    }
    
    // Reorder elements on initial load
    reorderElements();
    
    // Reorder elements on window resize
    window.addEventListener('resize', reorderElements);
    
    // Event Listeners for Buttons
    const showToolsButton = document.querySelector('.grid-button:nth-child(1)');
    const measurementsButton = document.querySelector('.grid-button:nth-child(2)');
    const substratesButton = document.querySelector('.grid-button:nth-child(3)');
    
    // Ensure the required elements exist
    if (showToolsButton && measurementsButton && substratesButton) {
        const wallpaperCalculator = document.querySelector('.wallpaper-calculator');
        const substrateOptions = document.querySelector('.substrate-all-options');
        const wallSpec = document.querySelector('.wall-spec.border-remove');
        const totalCostContainer = document.querySelector('.total-cost-container');
        const desktopOnlyMessage = document.getElementById('desktopOnlyMessage');
    
        // Function to hide all sections and the desktop-only message
        function hideAllSectionsAndMessage() {
            if (wallpaperCalculator) wallpaperCalculator.style.display = 'none';
            if (substrateOptions) substrateOptions.style.display = 'none';
            if (wallSpec) wallSpec.style.display = 'none';
            if (totalCostContainer) totalCostContainer.style.display = 'none';
            if (desktopOnlyMessage) desktopOnlyMessage.style.display = 'none';
        }
    
        // Event listener for "Measurements" button
        measurementsButton.addEventListener('click', function () {
            hideAllSectionsAndMessage();
            if (wallpaperCalculator) wallpaperCalculator.style.display = 'block';
        });
    
        // Event listener for "Substrates" button
        substratesButton.addEventListener('click', function () {
            hideAllSectionsAndMessage();
            if (substrateOptions) substrateOptions.style.display = 'block';
            if (wallSpec) wallSpec.style.display = 'flex';
            if (totalCostContainer) {
                totalCostContainer.style.display = 'flex';
                totalCostContainer.style.marginTop = '3rem';
            }
        });
    
        // Event listener for "Show Tools" button
        showToolsButton.addEventListener('click', function () {
            hideAllSectionsAndMessage();
            if (window.innerWidth <= 960) {
                if (desktopOnlyMessage) {
                    desktopOnlyMessage.textContent = "These tools are meant for desktop use, please open the page on a desktop.";
                    desktopOnlyMessage.style.display = 'block';
    
                    // Append the message above the button grid
                    const buttonGrid = document.querySelector('.button-grid');
                    if (buttonGrid && buttonGrid.parentNode) {
                        buttonGrid.parentNode.insertBefore(desktopOnlyMessage, buttonGrid);
                    }
                }
            }
        });
    } else {
        console.warn('Required buttons are missing.');
    }
    
}
});
